module.exports = __webpack_public_path__ + "static/img/s04.efa7b43d.png";